module.exports = __webpack_public_path__ + "static/media/11.51d0368a.jpeg";